import { type ChangeEventHandler, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import type { Directory } from '@witmetrics/utils';
import { parseFileInputPaths } from '@witmetrics/utils/files';
import { classes } from './utils';

export type DirectoryInputProps = {
  id: string;
  disabled?: boolean;
  className?: string;
  onSelect: (directory: Directory) => void;
};

const DirectoryInput = forwardRef<HTMLInputElement, DirectoryInputProps>(
  ({ id, disabled, className, onSelect }, ref) => {
    const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return onSelect(
        parseFileInputPaths(e.target.files ? Array.from(e.target.files) : [])
      );
    };

    return (
      <input
        ref={ref}
        disabled={disabled}
        className={twMerge(classes.input, className)}
        id={id}
        webkitdirectory="true"
        type="file"
        onChange={handleChange}
      />
    );
  }
);

export default DirectoryInput;
